import axios from 'axios'
import Utils from '@/common/Utils'
import store from '../store'

const headers = {
    'Content-Type': 'application/json',
    'Authorization': Utils.setRugToken()
}

function buildApiEndpoint (...subdirectories) {
    const url = new URL(['api-external', ...subdirectories].join('/').replace(/(?<!:)\/\/+/g, '/'), process.env.VUE_APP_RUG_URL)
    return url.href
}

export default class RugService {
    static async getAll (endpoint, params) {
        const { data } = await axios.get(buildApiEndpoint(endpoint),
            { params, headers, withCredentials: false }
        )

        return data
    }

    static async getOne (endpoint, id, params = {}) {
        const { data } = await axios.get(buildApiEndpoint(endpoint, id),
            { params, headers, withCredentials: false }
        )

        return data
    }

    static async classifyRelation (payload = {}) {
        const userData = {
            username: store.getters.user ? store.getters.user.userName : 'Desconocido',
            userId: store.getters.user ? store.getters.user.userId : null
        }

        let { data } = await axios.put(`${process.env.VUE_APP_RUG_URL}/api-external/relations/classify`,
            { ...payload, ...userData },
            { headers, withCredentials: false }
        )

        return data
    }

    static async commentRelation (payload = {}) {
        let { data } = await axios.post(`${process.env.VUE_APP_RUG_URL}/api-external/relations/comment`,
            payload,
            { headers, withCredentials: false }
        )

        return data
    }
}
